import {
    Component,
    ElementRef,
    HostListener,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import {
    CwUtils,
    PageOptions,
} from "../../../../../../../../shared/cw-utils/cw-utils.service";
import { Eartefact } from "../../../../../../../../shared/cw-backend/models/others/eartefact";
import { Attachment } from "../../../../../../../../shared/cw-backend/models/operational/medical/attachment/attachment";
import { AttachmentProvider } from "../../../../../../../../shared/cw-backend/providers/operational/medical/attachment.provider";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { SnackBarService } from "../../../../../../../../shared/cw-utils/snackbar.service";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from "@angular/material/dialog";
import { PatientAttachmentComponent } from "../patient-attachment/patient-attachment.component";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import moment from "moment";
import { PrintImageComponent } from "../print-image/print-image.component";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { ReportProvider } from "../../../../../../../../shared/cw-backend/providers/application/report/report.provider";
import { guiaModal } from "../../../reception/os/os.component";

@Component({
    selector: "app-patient-capture",
    templateUrl: "./patient-capture.component.html",
    styleUrls: ["./patient-capture.component.scss"],
})
export class PatientCaptureComponent implements OnInit, OnDestroy {
    AttachmentGroup: FormGroup;
    pageOptions: PageOptions;
    selectedFile: File;
    attachmentList = new Array<Attachment>();
    selectedAttachments: { name: string; content: string }[] = [];
    file: string;
    pdfSrc: any = null;
    eartefact = new Eartefact();
    attachment = new Attachment();
    zoom: any = "page-width";
    isSmallScreen = window.innerWidth;
    galleryMode: boolean = false;
    //tabela
    totalElements = 0;
    pagina = 0;
    tamanho = 0;
    capturedImage: string | null = null; // Para armazenar o print capturado
    videoDevices: MediaDeviceInfo[] = [];
    selectedDeviceId: string = "";
    isSaving = false;

    @ViewChild("videoElement", { static: true })
    videoElement!: ElementRef<HTMLVideoElement>;
    @ViewChild("canvasElement", { static: true })
    canvasElement!: ElementRef<HTMLCanvasElement>;

    @ViewChild("videoElementHD", { static: true })
    videoElementHD!: ElementRef<HTMLVideoElement>;
    @ViewChild("canvasElementHD", { static: true })
    canvasElementHD!: ElementRef<HTMLCanvasElement>;
    @ViewChild("videoElementMobile", { static: true })
    videoElementMobile!: ElementRef<HTMLVideoElement>;
    @ViewChild("canvasElementMobile", { static: true })
    canvasElementMobile!: ElementRef<HTMLCanvasElement>;

    constructor(
        private attachmentProvider: AttachmentProvider,
        private _formBuilder: FormBuilder,
        private fuseProgressBarModule: FuseProgressBarService,
        private snackbar: SnackBarService,
        private _matDialog: MatDialog,
        private reportProvider: ReportProvider,
        public dialogRef: MatDialogRef<PatientAttachmentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.pageOptions = new PageOptions();
    }

    ngOnInit() {
        this.AttachmentGroup = this.createAttachmentForm();
        this.pageOptions.argument = null;

        if (this.data.document == null) {
            this.getAttachmentNotDocument();
        } else {
            this.getAttachment();
        }

        this.getVideoDevices();
    }

    ngAfterViewInit() {
        if (this.videoDevices.length > 0) {
            this.selectedDeviceId = this.videoDevices[0].deviceId;
            this.startStream(this.selectedDeviceId);
        }
    }

    ngOnDestroy() {
        this.stopStream();
    }

    selectRow(attachment) {
        this.attachment = attachment;
        this.capturedImage = attachment.eartefact.content;
        this.AttachmentGroup.controls["name"].setValue(attachment.name);
    }

    createAttachmentForm(): FormGroup {
        return this._formBuilder.group({
            id: [null],
            name: new FormControl(null),
            dated: new FormControl(
                moment(this.data.dateSchedule).format("YYYY-MM-DD")
            ),
            eartefact: new FormControl(null),
            performer: new FormControl(
                this.data.performer ? this.data.performer : null
            ),
            insurance: new FormControl(
                this.data.patient ? this.data.patient.insurance : null
            ),
            patient: new FormControl(
                this.data.patient ? this.data.patient : null
            ),
            type: new FormControl(2),
            checked: new FormControl(0),
            document: new FormControl( this.data.document != null ? CwUtils.extractId(this.data.document) : null),
        });
    }

    switchFind (event?, type?) {
        if (this.data.type === "all") {
            this.getAttachmentNotDocument(event, type)
        } else {
            this.getAttachment(event, type);
        }
    }

    getAttachment(event?, type?) {
        this.fuseProgressBarModule.show();

        switch (type) {
            case "short":
                this.pageOptions.fieldSort = event.active;
                this.pageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.pageOptions.page = event.pageIndex;
                this.pageOptions.sizePage = event.pageSize;
                break;

            default:
                this.pageOptions.page = 0;
                this.pageOptions.sizePage = 12;
                break;
        }

        this.pageOptions.fieldSort = "dated";
        this.pageOptions.sortDirection = "desc";

        this.attachmentProvider
            .getPageByTypeAndPatientIdAndDocumentStorage(
                this.pageOptions,
                this.data.patient.id,
                2,
                this.data.document.id
            )
            .then((attachment) => {
                this.attachmentList = attachment.body.content;
                const dados = attachment.body;
                this.totalElements = dados.totalElements;
                this.pagina = dados.number;

                this.fuseProgressBarModule.hide();
            })
            .catch((error) => {
                this.fuseProgressBarModule.hide();
            });
    }

    getAttachmentNotDocument(event?, type?) {
        this.fuseProgressBarModule.show();

        switch (type) {
            case "short":
                this.pageOptions.fieldSort = event.active;
                this.pageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.pageOptions.page = event.pageIndex;
                this.pageOptions.sizePage = event.pageSize;
                break;

            default:
                this.pageOptions.page = 0;
                this.pageOptions.sizePage = 12;
                break;
        }

        this.pageOptions.fieldSort = "dated";
        this.pageOptions.sortDirection = "desc";

        this.attachmentProvider
            .getPageByTypeAndPatientIdStorage(
                this.pageOptions,
                this.data.patient.id,
                2
            )
            .then((attachment) => {
                this.attachmentList = attachment.body.content;
                const dados = attachment.body;
                this.totalElements = dados.totalElements;
                this.pagina = dados.number;

                this.fuseProgressBarModule.hide();
            })
            .catch((error) => {
                this.fuseProgressBarModule.hide();
            });
    }

    getColorChip(type) {
        switch (type) {
            case "application/pdf":
                return "primary";

                break;

            case "image/png":
                return "accent";

                break;

            case "image/jpeg":
                return "accent";

                break;

            case "video/mp4":
                return "warn";

                break;

            default:
                return "none";

                break;
        }
    }

    getIconChip(type) {
        switch (type) {
            case "application/pdf":
                return "picture_as_pdf";

                break;

            case "image/png":
                return "photo_library";

                break;

            case "image/jpeg":
                return "photo_library";

                break;

            case "video/mp4":
                return "video_library";

                break;

            default:
                return "content_copy";

                break;
        }
    }

    insert() {
        if (this.eartefact.content == null) {
            this.snackbar.warnMessage("Nenhum arquivo selecionado!");
            this.isSaving = false;
            return;
        }

        this.AttachmentGroup.controls["eartefact"].setValue(this.eartefact);

        let data = this.AttachmentGroup.getRawValue();

        this.fuseProgressBarModule.show();
        this.AttachmentGroup.controls["name"].setValue(null);

        this.attachmentProvider
            .insertStorage(data)
            .then((response) => {
                if (this.data.document == null) {
                    this.getAttachmentNotDocument();
                } else {
                    this.getAttachment();
                }

                this.cancel();
                this.attachment = response.body.data;
                this.AttachmentGroup.controls["name"].setValue(null);
                this.AttachmentGroup = this.createAttachmentForm();
                this.fuseProgressBarModule.hide();

                this.isSaving = false;
            })
            .catch(() => {
                this.isSaving = false;
            });
    }

    download(file) {
        const linkSource = file.eartefact.content;
        const downloadLink = document.createElement("a");
        const fileName = file.eartefact.name;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    deleteAttachement(id) {
        this.fuseProgressBarModule.show();

        const confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: true,
            }
        );

        confirmDialogRef.componentInstance.action = "delete";
        confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.fuseProgressBarModule.hide();

                this.attachmentProvider.deleteStorage(id).then((res) => {
                    if (this.data.document == null) {
                        this.getAttachmentNotDocument();
                    } else {
                        this.getAttachment();
                    }
                    this.cancel();
                });
            } else {
                this.fuseProgressBarModule.hide();
            }
            this.capturedImage = null;
        });
    }

    openPreviewDocument(row) {
        this.pdfSrc = row.eartefact.content;

        switch (row.eartefact.type) {
            case "application/pdf":
                this.file = "pdf";

                break;

            case "image/png":
                this.file = "image";

                break;

            case "image/jpeg":
                this.file = "image";

                break;

            case "video/mp4":
                this.file = "video";

                break;

            default:
                this.file = "notFile";

                break;
        }
    }

    cancel() {
        this.pdfSrc = null;
        this.selectedFile = null;
        this.file = null;
        this.attachment = new Attachment();
        this.AttachmentGroup.controls["name"].setValue(null);
        this.AttachmentGroup.controls["name"].enable();
    }

    closeModal() {
        this.dialogRef.close();
    }

    async getVideoDevices() {
        const devices = await navigator.mediaDevices.enumerateDevices();
        this.videoDevices = devices.filter(
            (device) => device.kind === "videoinput"
        );

        if (this.videoDevices.length > 0) {
            this.selectedDeviceId = this.videoDevices[0].deviceId;
            this.startStream(this.selectedDeviceId);
        }
    }

    async startStream(deviceId?: string) {
        try {
            // Para de qualquer stream anterior antes de iniciar um novo
            this.stopStream();

            // Verifica se há suporte ao getUserMedia
            if (
                !navigator.mediaDevices ||
                !navigator.mediaDevices.getUserMedia
            ) {
                console.error("Navegador não suporta getUserMedia");
                return;
            }

            // Configuração dos parâmetros da câmera
            const constraints: MediaStreamConstraints = {
                video: deviceId ? { deviceId: { exact: deviceId } } : true, // Se não houver deviceId, pega qualquer câmera disponível
            };

            // Obtém a stream de vídeo
            const stream = await navigator.mediaDevices.getUserMedia(
                constraints
            );

            // Atribui a stream para os elementos de vídeo visíveis por breakpoint.
            if (this.videoElement?.nativeElement) {
                this.videoElement.nativeElement.srcObject = stream;
            }

            if (this.videoElementHD?.nativeElement) {
                this.videoElementHD.nativeElement.srcObject = stream;
            }

            if (this.videoElementMobile?.nativeElement) {
                this.videoElementMobile.nativeElement.srcObject = stream;
            }
        } catch (error) {
            console.error("Erro ao acessar a câmera:", error);
        }
    }

    stopStream() {
        if (this.videoElement?.nativeElement?.srcObject) {
            const stream = this.videoElement.nativeElement
                .srcObject as MediaStream;
            stream.getTracks().forEach((track) => track.stop());
            this.videoElement.nativeElement.srcObject = null;
        }

        if (this.videoElementHD?.nativeElement?.srcObject) {
            const streamHD = this.videoElementHD.nativeElement
                .srcObject as MediaStream;
            streamHD.getTracks().forEach((track) => track.stop());
            this.videoElementHD.nativeElement.srcObject = null;
        }

        if (this.videoElementMobile?.nativeElement?.srcObject) {
            const streamMobile = this.videoElementMobile.nativeElement
                .srcObject as MediaStream;
            streamMobile.getTracks().forEach((track) => track.stop());
            this.videoElementMobile.nativeElement.srcObject = null;
        }
    }

    activateGallery() {
        this.selectedAttachments = [];
        this.galleryMode = !this.galleryMode;
    }

    async onDeviceChange() {
        await this.startStream(this.selectedDeviceId);
    }

    captureFrame() {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;
        const video =
            this.isMobileView() && this.videoElementMobile?.nativeElement
                ? this.videoElementMobile.nativeElement
                : this.videoElement.nativeElement;
        const canvas =
            this.isMobileView() && this.canvasElementMobile?.nativeElement
                ? this.canvasElementMobile.nativeElement
                : this.canvasElement.nativeElement;
        const context = canvas.getContext("2d");

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        context?.drawImage(video, 0, 0, canvas.width, canvas.height);

        this.capturedImage = canvas.toDataURL("image/png");

        this.eartefact.content = this.capturedImage;
        this.eartefact.type = "image/png";
        this.eartefact.dateAt = new Date(this.data.dateSchedule);
        this.eartefact.notes = "capture-" + this.eartefact.dateAt;
        this.eartefact.name = "capture-" + this.eartefact.dateAt;

        this.AttachmentGroup.controls["name"].setValue(
            "capture-" +
                moment(this.eartefact.dateAt).format("DD/MM/YYYY HH:SS")
        );

        this.insert();
    }

    isMobileView(): boolean {
        return typeof window !== "undefined" && window.innerWidth <= 959;
    }

    insertDescription() {
        if (this.AttachmentGroup.controls["name"].value != null) {
            this.attachmentProvider
                .insertDescription(
                    this.AttachmentGroup.controls["name"].value,
                    this.attachment.id
                )
                .then((res) => {
                    this.capturedImage = null;
                    if (this.data.document == null) {
                        this.getAttachmentNotDocument();
                    } else {
                        this.getAttachment();
                    }
                });
        }
    }

    openImageDialog(chip: any): void {
        this._matDialog.open(PrintImageComponent, {
            data: { imageUrl: chip.eartefact.content },
            width: "60%",
            maxHeight: "90vh",
            panelClass: "custom-dialog",
        });
    }

    checkedCapture(event: any, chip: any) {
        const isChecked = event.checked;
        console.log(isChecked);
        if (isChecked) {
            this.selectedAttachments.push({
                name: chip.name,
                content: chip.eartefact.content,
            });
        } else {
            this.selectedAttachments = this.selectedAttachments.filter(
                (item) => item.name !== chip.name
            );
        }

        console.log(this.selectedAttachments);
    }

    print() {
        this.fuseProgressBarModule.show();
        this.snackbar.successMessage("Imprimindo imagens...");

        this.reportProvider
            .getPdfCapture(this.selectedAttachments, this.data.patient.id)
            .then((x) => {
                this.pdfSrc = x.pdf as string;

                var newBlob = new Blob([x], { type: "application/pdf" });

                const nav = window.navigator as any;

                if (nav && nav.msSaveOrOpenBlob) {
                    nav.msSaveOrOpenBlob(newBlob);
                    return;
                }

                const data = window.URL.createObjectURL(newBlob);

                this.fuseProgressBarModule.hide();
                const dialogRef = this._matDialog.open(guiaModal, {
                    height: "100%",
                    width: "120%",
                    data: this.pdfSrc,
                });

                 this.fuseProgressBarModule.hide();

                dialogRef.afterClosed().subscribe((result) => {
                    this.pdfSrc = null;
                });
            });
    }
}
